import liferayService from "./liferay";
import { REACT_APP_SCOPE_KEY } from "./utils";

export const createParticipant = async (payload) => {
    return new Promise(async (resolve, reject) => {
        try {
            const data = liferayService.post(`o/c/participantencheres/scopes/${REACT_APP_SCOPE_KEY}`, payload)
            resolve(data);
        } catch (error) {
            reject(error);
        }
    });
};
